<template>
  <div class="locale-changer">
    <v-menu v-model="menu" bottom offset-y>
      <template #activator="{ on }">
        <div class="pointer" v-on="on">
          <country-flag
            :value="$i18n.locale"
            :country="currentCountry"
            :rounded="true"
            size="normal"
          />
        </div>
      </template>
      <v-list
        class="pa-0"
        :style="{ maxHeight: dynamicMaxHeight + 'px', overflowY: 'auto' }"
      >
        <v-list-item-group v-model="$i18n.locale">
          <v-list-item v-for="(item, i) in langs" :key="i" :value="item.lang">
            <country-flag
              :value="item.lang"
              :rounded="true"
              :country="item.country"
              size="normal"
            />
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import CountryFlag from 'vue-country-flag'
import DeviceMixin from 'components/mixins/device-mixin'
import { BOOM_LANGUAGES } from '@/consts'

export default {
  name: 'LocaleChanger',
  mixins: [DeviceMixin],
  components: { CountryFlag },
  data() {
    return {
      menu: false,
      langs: BOOM_LANGUAGES,
      windowHeight: window.innerHeight,
    }
  },
  computed: {
    currentLocale() {
      if (this.$i18n) {
        return this.$i18n.locale
      }
      return null
    },
    currentCountry() {
      return (
        this.langs.find(l => l.lang === this.currentLocale) || this.langs[0]
      ).country
    },
    dynamicMaxHeight() {
      // Calculate available viewport height
      const viewportHeight = this.windowHeight

      // Estimate item height (country flag + padding) - approximately 48px per item
      const itemHeight = 48
      const totalItemsHeight = this.langs.length * itemHeight

      // Calculate available space - use most of the viewport minus header/footer space
      const reservedSpace = 100 // Reserve space for header/navigation
      const availableHeight = viewportHeight - reservedSpace

      // Return the smaller of: total items height or available height
      // Minimum of 200px to ensure good usability
      return Math.max(200, Math.min(totalItemsHeight, availableHeight))
    },
  },
  watch: {
    currentLocale: {
      handler(newValue) {
        if (newValue === 'he') {
          document.dir = 'rtl'
          this.$vuetify.rtl = true
        } else {
          document.dir = 'ltr'
          this.$vuetify.rtl = false
        }

        this.$store.dispatch('users/updateProfile', {
          id: this.$store.getters.CurrentUserId,
          locale: newValue,
        })
      },
    },
  },
  mounted() {
    document.dir = this.currentLocale === 'he' ? 'rtl' : 'ltr'

    // Add resize listener to update height when window size changes
    this.handleResize = () => {
      this.windowHeight = window.innerHeight
    }
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // Clean up resize listener
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize)
    }
  },
}
</script>
